import { createAction } from '@reduxjs/toolkit';
import { ICustomer } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_CUSTOMERS } from '../../../../common';

export const setCustomers = createAction<ICustomer[]>(
  `${MN_CUSTOMERS}/${TYPE_LIST}/${ACT_SET}`,
);
